import {css} from '../theme/css'

export const classes = {
  root: css`
    margin: 0;
  `,
  fullscreenHeight: css`
    height: 100vh;
  `,
  fullWidth: css`
    width: 100%;
  `,
}
